import { useTranslation } from 'react-i18next';
import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { eventCashFlowInitialValues } from 'components/organisms/forms/event-cash-flow/EventCashFlowForm';
import { useCustomParamId } from 'hooks/useParamId';
import i18next from 'i18next';
import { eventCashFlowQueryToForm } from 'middleware/event-cash-flow';
import { PiPencilSimpleLine, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDeleteEventIncome, useGetEventIncome } from 'services/events/income';

const EventIncome = () => {
  const { t } = useTranslation();
  const eventIncomeId = useCustomParamId('eventIncomeId');
  const { pathname } = useLocation();
  const { isPending, mutateAsync } = useDeleteEventIncome();

  const navigate = useNavigate();

  const { data: eventIncome, isLoading } = useGetEventIncome(eventIncomeId);

  const handleDeleteEventIncome = async () => {
    await mutateAsync({ eventIncomeId }, {
      onSuccess: () => navigate(`/event/${eventIncome?.eventId}/balance`),
    });
  };

  return (
    <Form.EventCashFlow
      i18nextPrefix='event-income'
      initialValues={
        eventIncome ? eventCashFlowQueryToForm(eventIncome, 'income') : eventCashFlowInitialValues
      }
      onSubmit={() => {}}
      tittle={eventIncome?.incomeName ?? i18next.t('event-income.title.individual')}
      customBackItem={
        <Button type='button' onlyIcon onClick={() => navigate(`/event/${eventIncome?.eventId}/balance`)}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      status={{ displayMode: true, isLoading }}
      topbarContent={
        <div className='flex gap-2 items-center'>
            <Button
              isClear
              onlyIcon
              onClick={() => {
                eventIncome &&
                  navigate(`/event/${eventIncome.eventId}/income/edit/${eventIncomeId}`, {
                    replace: true,
                  });
              }}>
              <Button.Description description={t('button.edit')} />

              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
            <MagellanPopups.DeleteWarning
              onRemove={handleDeleteEventIncome}
              removeLoading={isPending}
              name={eventIncome?.incomeName}
            />
        </div>
      }
    />
  );
};

export default EventIncome; 